// extracted by mini-css-extract-plugin
export default {"homeTabButton":"styles_homeTabButton__AoN9P"};